import { injectable } from "inversify";
import { Either, right } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../domain/entities/ExceptionEntity";
import BucketEntity from "../../../domain/entities/BucketEntity";
import UserEntity from "../../../domain/entities/UserEntity";
import BucketRepository from "../../../domain/repositories/BucketRepository";

const fakeBuckets: BucketEntity[] = [
    { bucket_id: 13, name: "itel", parent_bucket: null, user_count: 142 },
    { bucket_id: 20, name: "Bogota", parent_bucket: 13, user_count: 45 },
    { bucket_id: 21, name: "Manila", parent_bucket: 13, user_count: 55 },
    { bucket_id: 22, name: "Cape Town", parent_bucket: 13, user_count: 42 },
    { bucket_id: 30, name: "Acme Corp", parent_bucket: 20, user_count: 20 },
    { bucket_id: 31, name: "GlobalTech", parent_bucket: 20, user_count: 25 },
    { bucket_id: 32, name: "MegaCo", parent_bucket: 21, user_count: 30 },
    { bucket_id: 33, name: "StarInc", parent_bucket: 22, user_count: 20 },
    { bucket_id: 40, name: "J. Smith", parent_bucket: 30, user_count: 10 },
    { bucket_id: 41, name: "M. Jones", parent_bucket: 30, user_count: 10 },
    { bucket_id: 42, name: "R. Lee", parent_bucket: 31, user_count: 25 },
];

@injectable()
class BucketRepositoryFake implements BucketRepository {
    getAll = async (): Promise<Either<ExceptionEntity, BucketEntity[]>> => right(fakeBuckets);

    getUsersInBucket = async (bucketId: number, page: number, perPage: number): Promise<Either<ExceptionEntity, UserEntity[]>> => {
        const fakeUsers: UserEntity[] = Array.from({ length: 5 }, (_, i) => ({
            id: `${bucketId}-${i}`,
            name: `User ${i + 1}`,
            email: `user${i + 1}@example.com`,
            phone: "",
            status: "active" as any,
            image: undefined,
            firstname: `User`,
            lastname: `${i + 1}`,
            role_id: "6",
            systemid: 100 + i,
            user_id: 100 + i,
            cognito_user: "",
            permissions: undefined,
            area: "itel",
            position: "Agent",
            role: { name: "agent" },
            business_unit: "itel",
            profile_picture: undefined,
        }));
        return right(fakeUsers);
    };

    moveUserToBucket = async (userId: string, location: string, client: string, supervisor: string): Promise<Either<ExceptionEntity, string>> => {
        return right("User moved successfully (fake)");
    };
}

export default BucketRepositoryFake;
